"use client"
import { Container, Grid } from "@mui/material"
import { StatsCards } from "./stats-cards"
import { CampaignsSection } from "./campaigns-section"
import { CollaborationsSection } from "./collaborations-section"
import { BlogsSection } from "./blogs-section"
import { PlaylistsSection } from "./playlists-section"
import { useDashboardData } from "../../hooks/use-dashboard-data"
import CreditLedger from "./credit-ledger"
import LeaderboardCard from "./leaderboardcard"
import ProfileCompletion from "./profile-completion"

const DashboardCreator = () => {
  const {
    studioAnalyticData,
    creditLedgerData,
    leaderBoard,
    campaignDetails,
    collabRequest,
    blogs,
    officialPlaylists,
    loading
  } = useDashboardData()

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Grid container spacing={2}>
        {/* Stats Cards - Full Width */}
        <Grid item xs={12}>
          <StatsCards data={studioAnalyticData} loading={loading.stats} />
        </Grid>

        {/* Left Column: Profile, Campaigns, Collabs, Blogs */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2} direction="column">
            <Grid item>
              <ProfileCompletion />
            </Grid>
            <Grid item>
              <CampaignsSection campaigns={campaignDetails} loading={loading.campaigns} />
            </Grid>
            <Grid item>
              <CollaborationsSection collaborations={collabRequest} loading={loading.collaborations} />
            </Grid>
            <Grid item>
              <BlogsSection blogs={blogs} loading={loading.blogs} />
            </Grid>
          </Grid>
        </Grid>

        {/* Right Column: Credit Ledger, Leaderboard */}
        <Grid item xs={12} md={4}>
          <Grid container spacing={2} direction="column">
            <Grid item width={"100%"}>
              <LeaderboardCard data={leaderBoard} loading={loading.leader} />
            </Grid>
            <Grid item width={"100%"}>
              <CreditLedger data={creditLedgerData} loading={loading.stats} />
            </Grid>
          </Grid>
        </Grid>

        {/* Playlists - Full Width */}
        <Grid item xs={12}>
          {/* <PlaylistsSection playlists={officialPlaylists} loading={loading.playlists} /> */}
        </Grid>
      </Grid>
    </Container>
  )
}

export default DashboardCreator
